// extracted by mini-css-extract-plugin
module.exports = {"image-singular__image":"ImageSingular_image-singular__image__wK6vx","image-singular__image__image":"ImageSingular_image-singular__image__image__0aorq"};